/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PracovnikEosVO } from '../model';
// @ts-ignore
import { UserRightsVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * RightsControllerApi - axios parameter creator
 * @export
 */
export const RightsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Metoda pro přídání vlastníků tématu
         * @param {string} topicId Identifikátor tématu
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTopicOwners: async (topicId: string, requestBody?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('addTopicOwners', 'topicId', topicId)
            const localVarPath = `/api/rights/topic/{topicId}/owners`
                .replace(`{${"topicId"}}`, encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro odstranění práv daného uživatele
         * @param {number} layerId Identifikátor vrstvy
         * @param {number} pracovnikId ID pracovníka, kterému chceme odstranit oprávnění
         * @param {boolean} [layerReader] Zda odebrat pracovníkovi oprávnění pro čtení vrstvy
         * @param {boolean} [layerOwner] Odebrat pracovníka jako vlastníka vrstvy
         * @param {Array<number>} [akceId] ID akcí, které chceme pracovníkovi odebrat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserRights: async (layerId: number, pracovnikId: number, layerReader?: boolean, layerOwner?: boolean, akceId?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('deleteUserRights', 'layerId', layerId)
            // verify required parameter 'pracovnikId' is not null or undefined
            assertParamExists('deleteUserRights', 'pracovnikId', pracovnikId)
            const localVarPath = `/api/rights/layer/{layerId}`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pracovnikId !== undefined) {
                localVarQueryParameter['pracovnikId'] = pracovnikId;
            }

            if (layerReader !== undefined) {
                localVarQueryParameter['layerReader'] = layerReader;
            }

            if (layerOwner !== undefined) {
                localVarQueryParameter['layerOwner'] = layerOwner;
            }

            if (akceId) {
                localVarQueryParameter['akceId'] = akceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro načtení práv vrstvev katalogu
         * @param {number} catalogId Identifikátor katalogu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCatalogRights: async (catalogId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'catalogId' is not null or undefined
            assertParamExists('getAllCatalogRights', 'catalogId', catalogId)
            const localVarPath = `/api/rights/catalog/{catalogId}/all`
                .replace(`{${"catalogId"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro načtení práv vrstvy
         * @param {number} layerId Identifikátor vrstvy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLayerRights: async (layerId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getAllLayerRights', 'layerId', layerId)
            const localVarPath = `/api/rights/layer/{layerId}/all`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Načtení práv na dané vrstvy pro právě přihlášeného uživatele
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLayerRightsForLoggedInUser: async (requestBody?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/rights/layer/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro načtení práv vrstvev katalogu
         * @param {string} topicId Identifikátor tématu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTopicRights: async (topicId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('getAllTopicRights', 'topicId', topicId)
            const localVarPath = `/api/rights/topic/{topicId}/all`
                .replace(`{${"topicId"}}`, encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro načtení vlastníků tématu
         * @param {string} topicId Identifikátor tématu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicOwners: async (topicId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('getTopicOwners', 'topicId', topicId)
            const localVarPath = `/api/rights/topic/{topicId}/owners`
                .replace(`{${"topicId"}}`, encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro načtení identifikátorů témat vlastněných přihlášeným uživatelem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicsOwned: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/rights/topic/owner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro načtení všech vrstev, na které má uživatel právo (vlastník vrstvy nebo má právo na nějaké akce dané vrstvy)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWriteableLayersForLoggedInUser: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/rights/layer/writeable-layers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro načtení práv vrstvy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mamPrirazenouAplikaci: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/rights/eos/prirazeno`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro odstranění vlastníka tématu
         * @param {string} topicId Identifikátor tématu
         * @param {number} pracovnikId ID pracovníka mazaného vlastníka
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTopicOwner: async (topicId: string, pracovnikId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('removeTopicOwner', 'topicId', topicId)
            // verify required parameter 'pracovnikId' is not null or undefined
            assertParamExists('removeTopicOwner', 'pracovnikId', pracovnikId)
            const localVarPath = `/api/rights/topic/{topicId}/owners`
                .replace(`{${"topicId"}}`, encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pracovnikId !== undefined) {
                localVarQueryParameter['pracovnikId'] = pracovnikId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro úpravu práv daného uživatele
         * @param {number} layerId Identifikátor vrstvy
         * @param {boolean} [layerReader] Zda je pracovník oprávněn pro čtení vrstvy
         * @param {boolean} [layerOwner] Zda je pracovník vlastníkem vrstvy
         * @param {Array<number>} [akceId] ID akcí, které chceme, aby pracovník mohl nad danou vrstvou provádět (pokud chceme pracovníkovi všechny akce pro danou vrstvu odstranit, pošleme prázdné pole)
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRights: async (layerId: number, layerReader?: boolean, layerOwner?: boolean, akceId?: Array<number>, requestBody?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('updateUserRights', 'layerId', layerId)
            const localVarPath = `/api/rights/layer/{layerId}`
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (layerReader !== undefined) {
                localVarQueryParameter['layerReader'] = layerReader;
            }

            if (layerOwner !== undefined) {
                localVarQueryParameter['layerOwner'] = layerOwner;
            }

            if (akceId) {
                localVarQueryParameter['akceId'] = akceId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RightsControllerApi - functional programming interface
 * @export
 */
export const RightsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RightsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Metoda pro přídání vlastníků tématu
         * @param {string} topicId Identifikátor tématu
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTopicOwners(topicId: string, requestBody?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.addTopicOwners(topicId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro odstranění práv daného uživatele
         * @param {number} layerId Identifikátor vrstvy
         * @param {number} pracovnikId ID pracovníka, kterému chceme odstranit oprávnění
         * @param {boolean} [layerReader] Zda odebrat pracovníkovi oprávnění pro čtení vrstvy
         * @param {boolean} [layerOwner] Odebrat pracovníka jako vlastníka vrstvy
         * @param {Array<number>} [akceId] ID akcí, které chceme pracovníkovi odebrat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserRights(layerId: number, pracovnikId: number, layerReader?: boolean, layerOwner?: boolean, akceId?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserRights(layerId, pracovnikId, layerReader, layerOwner, akceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro načtení práv vrstvev katalogu
         * @param {number} catalogId Identifikátor katalogu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCatalogRights(catalogId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserRightsVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCatalogRights(catalogId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro načtení práv vrstvy
         * @param {number} layerId Identifikátor vrstvy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLayerRights(layerId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserRightsVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLayerRights(layerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Načtení práv na dané vrstvy pro právě přihlášeného uživatele
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLayerRightsForLoggedInUser(requestBody?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserRightsVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLayerRightsForLoggedInUser(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro načtení práv vrstvev katalogu
         * @param {string} topicId Identifikátor tématu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTopicRights(topicId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserRightsVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTopicRights(topicId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro načtení vlastníků tématu
         * @param {string} topicId Identifikátor tématu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopicOwners(topicId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PracovnikEosVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopicOwners(topicId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro načtení identifikátorů témat vlastněných přihlášeným uživatelem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopicsOwned(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopicsOwned(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro načtení všech vrstev, na které má uživatel právo (vlastník vrstvy nebo má právo na nějaké akce dané vrstvy)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWriteableLayersForLoggedInUser(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getWriteableLayersForLoggedInUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro načtení práv vrstvy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mamPrirazenouAplikaci(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.mamPrirazenouAplikaci(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro odstranění vlastníka tématu
         * @param {string} topicId Identifikátor tématu
         * @param {number} pracovnikId ID pracovníka mazaného vlastníka
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeTopicOwner(topicId: string, pracovnikId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.removeTopicOwner(topicId, pracovnikId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro úpravu práv daného uživatele
         * @param {number} layerId Identifikátor vrstvy
         * @param {boolean} [layerReader] Zda je pracovník oprávněn pro čtení vrstvy
         * @param {boolean} [layerOwner] Zda je pracovník vlastníkem vrstvy
         * @param {Array<number>} [akceId] ID akcí, které chceme, aby pracovník mohl nad danou vrstvou provádět (pokud chceme pracovníkovi všechny akce pro danou vrstvu odstranit, pošleme prázdné pole)
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserRights(layerId: number, layerReader?: boolean, layerOwner?: boolean, akceId?: Array<number>, requestBody?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserRights(layerId, layerReader, layerOwner, akceId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RightsControllerApi - factory interface
 * @export
 */
export const RightsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RightsControllerApiFp(configuration)
    return {
        /**
         * Metoda pro přídání vlastníků tématu
         * @param {string} topicId Identifikátor tématu
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTopicOwners(topicId: string, requestBody?: Array<number>, options?: any): AxiosPromise<void> {
            return localVarFp.addTopicOwners(topicId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro odstranění práv daného uživatele
         * @param {number} layerId Identifikátor vrstvy
         * @param {number} pracovnikId ID pracovníka, kterému chceme odstranit oprávnění
         * @param {boolean} [layerReader] Zda odebrat pracovníkovi oprávnění pro čtení vrstvy
         * @param {boolean} [layerOwner] Odebrat pracovníka jako vlastníka vrstvy
         * @param {Array<number>} [akceId] ID akcí, které chceme pracovníkovi odebrat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserRights(layerId: number, pracovnikId: number, layerReader?: boolean, layerOwner?: boolean, akceId?: Array<number>, options?: any): AxiosPromise<void> {
            return localVarFp.deleteUserRights(layerId, pracovnikId, layerReader, layerOwner, akceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro načtení práv vrstvev katalogu
         * @param {number} catalogId Identifikátor katalogu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCatalogRights(catalogId: number, options?: any): AxiosPromise<Array<UserRightsVO>> {
            return localVarFp.getAllCatalogRights(catalogId, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro načtení práv vrstvy
         * @param {number} layerId Identifikátor vrstvy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLayerRights(layerId: number, options?: any): AxiosPromise<Array<UserRightsVO>> {
            return localVarFp.getAllLayerRights(layerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Načtení práv na dané vrstvy pro právě přihlášeného uživatele
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLayerRightsForLoggedInUser(requestBody?: Array<number>, options?: any): AxiosPromise<Array<UserRightsVO>> {
            return localVarFp.getAllLayerRightsForLoggedInUser(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro načtení práv vrstvev katalogu
         * @param {string} topicId Identifikátor tématu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTopicRights(topicId: string, options?: any): AxiosPromise<Array<UserRightsVO>> {
            return localVarFp.getAllTopicRights(topicId, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro načtení vlastníků tématu
         * @param {string} topicId Identifikátor tématu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicOwners(topicId: string, options?: any): AxiosPromise<Array<PracovnikEosVO>> {
            return localVarFp.getTopicOwners(topicId, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro načtení identifikátorů témat vlastněných přihlášeným uživatelem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicsOwned(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getTopicsOwned(options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro načtení všech vrstev, na které má uživatel právo (vlastník vrstvy nebo má právo na nějaké akce dané vrstvy)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWriteableLayersForLoggedInUser(options?: any): AxiosPromise<Array<number>> {
            return localVarFp.getWriteableLayersForLoggedInUser(options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro načtení práv vrstvy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mamPrirazenouAplikaci(options?: any): AxiosPromise<boolean> {
            return localVarFp.mamPrirazenouAplikaci(options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro odstranění vlastníka tématu
         * @param {string} topicId Identifikátor tématu
         * @param {number} pracovnikId ID pracovníka mazaného vlastníka
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTopicOwner(topicId: string, pracovnikId: number, options?: any): AxiosPromise<void> {
            return localVarFp.removeTopicOwner(topicId, pracovnikId, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro úpravu práv daného uživatele
         * @param {number} layerId Identifikátor vrstvy
         * @param {boolean} [layerReader] Zda je pracovník oprávněn pro čtení vrstvy
         * @param {boolean} [layerOwner] Zda je pracovník vlastníkem vrstvy
         * @param {Array<number>} [akceId] ID akcí, které chceme, aby pracovník mohl nad danou vrstvou provádět (pokud chceme pracovníkovi všechny akce pro danou vrstvu odstranit, pošleme prázdné pole)
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRights(layerId: number, layerReader?: boolean, layerOwner?: boolean, akceId?: Array<number>, requestBody?: Array<number>, options?: any): AxiosPromise<void> {
            return localVarFp.updateUserRights(layerId, layerReader, layerOwner, akceId, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RightsControllerApi - interface
 * @export
 * @interface RightsControllerApi
 */
export interface RightsControllerApiInterface {
    /**
     * Metoda pro přídání vlastníků tématu
     * @param {string} topicId Identifikátor tématu
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApiInterface
     */
    addTopicOwners(topicId: string, requestBody?: Array<number>, options?: any): AxiosPromise<void>;

    /**
     * Metoda pro odstranění práv daného uživatele
     * @param {number} layerId Identifikátor vrstvy
     * @param {number} pracovnikId ID pracovníka, kterému chceme odstranit oprávnění
     * @param {boolean} [layerReader] Zda odebrat pracovníkovi oprávnění pro čtení vrstvy
     * @param {boolean} [layerOwner] Odebrat pracovníka jako vlastníka vrstvy
     * @param {Array<number>} [akceId] ID akcí, které chceme pracovníkovi odebrat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApiInterface
     */
    deleteUserRights(layerId: number, pracovnikId: number, layerReader?: boolean, layerOwner?: boolean, akceId?: Array<number>, options?: any): AxiosPromise<void>;

    /**
     * Metoda pro načtení práv vrstvev katalogu
     * @param {number} catalogId Identifikátor katalogu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApiInterface
     */
    getAllCatalogRights(catalogId: number, options?: any): AxiosPromise<Array<UserRightsVO>>;

    /**
     * Metoda pro načtení práv vrstvy
     * @param {number} layerId Identifikátor vrstvy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApiInterface
     */
    getAllLayerRights(layerId: number, options?: any): AxiosPromise<Array<UserRightsVO>>;

    /**
     * Načtení práv na dané vrstvy pro právě přihlášeného uživatele
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApiInterface
     */
    getAllLayerRightsForLoggedInUser(requestBody?: Array<number>, options?: any): AxiosPromise<Array<UserRightsVO>>;

    /**
     * Metoda pro načtení práv vrstvev katalogu
     * @param {string} topicId Identifikátor tématu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApiInterface
     */
    getAllTopicRights(topicId: string, options?: any): AxiosPromise<Array<UserRightsVO>>;

    /**
     * Metoda pro načtení vlastníků tématu
     * @param {string} topicId Identifikátor tématu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApiInterface
     */
    getTopicOwners(topicId: string, options?: any): AxiosPromise<Array<PracovnikEosVO>>;

    /**
     * Metoda pro načtení identifikátorů témat vlastněných přihlášeným uživatelem
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApiInterface
     */
    getTopicsOwned(options?: any): AxiosPromise<Array<string>>;

    /**
     * Metoda pro načtení všech vrstev, na které má uživatel právo (vlastník vrstvy nebo má právo na nějaké akce dané vrstvy)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApiInterface
     */
    getWriteableLayersForLoggedInUser(options?: any): AxiosPromise<Array<number>>;

    /**
     * Metoda pro načtení práv vrstvy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApiInterface
     */
    mamPrirazenouAplikaci(options?: any): AxiosPromise<boolean>;

    /**
     * Metoda pro odstranění vlastníka tématu
     * @param {string} topicId Identifikátor tématu
     * @param {number} pracovnikId ID pracovníka mazaného vlastníka
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApiInterface
     */
    removeTopicOwner(topicId: string, pracovnikId: number, options?: any): AxiosPromise<void>;

    /**
     * Metoda pro úpravu práv daného uživatele
     * @param {number} layerId Identifikátor vrstvy
     * @param {boolean} [layerReader] Zda je pracovník oprávněn pro čtení vrstvy
     * @param {boolean} [layerOwner] Zda je pracovník vlastníkem vrstvy
     * @param {Array<number>} [akceId] ID akcí, které chceme, aby pracovník mohl nad danou vrstvou provádět (pokud chceme pracovníkovi všechny akce pro danou vrstvu odstranit, pošleme prázdné pole)
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApiInterface
     */
    updateUserRights(layerId: number, layerReader?: boolean, layerOwner?: boolean, akceId?: Array<number>, requestBody?: Array<number>, options?: any): AxiosPromise<void>;

}

/**
 * RightsControllerApi - object-oriented interface
 * @export
 * @class RightsControllerApi
 * @extends {BaseAPI}
 */
export class RightsControllerApi extends BaseAPI implements RightsControllerApiInterface {
    /**
     * Metoda pro přídání vlastníků tématu
     * @param {string} topicId Identifikátor tématu
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApi
     */
    public addTopicOwners(topicId: string, requestBody?: Array<number>, options?: any) {
        return RightsControllerApiFp(this.configuration).addTopicOwners(topicId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro odstranění práv daného uživatele
     * @param {number} layerId Identifikátor vrstvy
     * @param {number} pracovnikId ID pracovníka, kterému chceme odstranit oprávnění
     * @param {boolean} [layerReader] Zda odebrat pracovníkovi oprávnění pro čtení vrstvy
     * @param {boolean} [layerOwner] Odebrat pracovníka jako vlastníka vrstvy
     * @param {Array<number>} [akceId] ID akcí, které chceme pracovníkovi odebrat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApi
     */
    public deleteUserRights(layerId: number, pracovnikId: number, layerReader?: boolean, layerOwner?: boolean, akceId?: Array<number>, options?: any) {
        return RightsControllerApiFp(this.configuration).deleteUserRights(layerId, pracovnikId, layerReader, layerOwner, akceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro načtení práv vrstvev katalogu
     * @param {number} catalogId Identifikátor katalogu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApi
     */
    public getAllCatalogRights(catalogId: number, options?: any) {
        return RightsControllerApiFp(this.configuration).getAllCatalogRights(catalogId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro načtení práv vrstvy
     * @param {number} layerId Identifikátor vrstvy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApi
     */
    public getAllLayerRights(layerId: number, options?: any) {
        return RightsControllerApiFp(this.configuration).getAllLayerRights(layerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Načtení práv na dané vrstvy pro právě přihlášeného uživatele
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApi
     */
    public getAllLayerRightsForLoggedInUser(requestBody?: Array<number>, options?: any) {
        return RightsControllerApiFp(this.configuration).getAllLayerRightsForLoggedInUser(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro načtení práv vrstvev katalogu
     * @param {string} topicId Identifikátor tématu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApi
     */
    public getAllTopicRights(topicId: string, options?: any) {
        return RightsControllerApiFp(this.configuration).getAllTopicRights(topicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro načtení vlastníků tématu
     * @param {string} topicId Identifikátor tématu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApi
     */
    public getTopicOwners(topicId: string, options?: any) {
        return RightsControllerApiFp(this.configuration).getTopicOwners(topicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro načtení identifikátorů témat vlastněných přihlášeným uživatelem
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApi
     */
    public getTopicsOwned(options?: any) {
        return RightsControllerApiFp(this.configuration).getTopicsOwned(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro načtení všech vrstev, na které má uživatel právo (vlastník vrstvy nebo má právo na nějaké akce dané vrstvy)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApi
     */
    public getWriteableLayersForLoggedInUser(options?: any) {
        return RightsControllerApiFp(this.configuration).getWriteableLayersForLoggedInUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro načtení práv vrstvy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApi
     */
    public mamPrirazenouAplikaci(options?: any) {
        return RightsControllerApiFp(this.configuration).mamPrirazenouAplikaci(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro odstranění vlastníka tématu
     * @param {string} topicId Identifikátor tématu
     * @param {number} pracovnikId ID pracovníka mazaného vlastníka
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApi
     */
    public removeTopicOwner(topicId: string, pracovnikId: number, options?: any) {
        return RightsControllerApiFp(this.configuration).removeTopicOwner(topicId, pracovnikId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro úpravu práv daného uživatele
     * @param {number} layerId Identifikátor vrstvy
     * @param {boolean} [layerReader] Zda je pracovník oprávněn pro čtení vrstvy
     * @param {boolean} [layerOwner] Zda je pracovník vlastníkem vrstvy
     * @param {Array<number>} [akceId] ID akcí, které chceme, aby pracovník mohl nad danou vrstvou provádět (pokud chceme pracovníkovi všechny akce pro danou vrstvu odstranit, pošleme prázdné pole)
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RightsControllerApi
     */
    public updateUserRights(layerId: number, layerReader?: boolean, layerOwner?: boolean, akceId?: Array<number>, requestBody?: Array<number>, options?: any) {
        return RightsControllerApiFp(this.configuration).updateUserRights(layerId, layerReader, layerOwner, akceId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}
